// extracted by mini-css-extract-plugin
export default {"button":"MainButton_button__x+6zZ","buttonIcon":"MainButton_buttonIcon__HcHCW","dark":"MainButton_dark__rthef","light":"MainButton_light__bm4ez"};